<template>
  <div class="invest-wrapper">
    <div class="invest-content">
      <div class="invest-step-back">
        <v-icon color="#333333" size="22" @click="$router.go(-1)">
          mdi-arrow-left
        </v-icon>
      </div>

      <h3 class="invest-title">
        {{ $t(`investment.compassCompleteData.titles.${timeoutReached ? 'mandatory' : 'reminder'}`) }}
      </h3>

      <div class="invest-text">
        {{ $t("investment.compassCompleteData.text") }}
      </div>

      <div class="button-row">
        <NewButton
          :text="$t('investment.compassCompleteData.buttons.complete')"
          @on-click="$router.push({ name: 'account' })"
        />

        <NewButton
          button-class="black-outlined"
          :text="$t('investment.compassCompleteData.buttons.later', { remainingDays: daysToCompleteData })"
          @on-click="$router.push({ name: 'investBankSelect' })"
          v-if="!timeoutReached"
        />

      </div>

      <div
        class="invest-cancel-label"
        @click="$router.push({ name: 'home' })"
      >
        {{ $t("base.cancel") }}
      </div>
    </div>
  </div>
</template>

<script>
import NewButton from "@/components/shared/NewButton.vue";
import { mapGetters } from "vuex";

export default {
  name: "CompassCompleteData",

  components: { NewButton },

  computed: {
    ...mapGetters(["daysToCompleteData"]),

    timeoutReached() {
      return this.daysToCompleteData === 0;
    },
  },

};
</script>

<style lang="scss" scoped>

.invest-content{
    max-width: 420px;
}

.button-row > *:not(:first-child){
  margin-top: 20px;
}

.invest-title{
    font-family: Work Sans;
    font-size: 18px;
    font-weight: 500;
    line-height: 28.8px;
    margin-bottom: 40px;

}

.invest-text{
    font-size: 14px;
    font-weight: 500;
    line-height: 22.4px;
    color: #333;
    margin-bottom: 40px;
}

.invest-cancel-label {
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  text-align: right;
  color: #646363;
  margin-top: 40px;

  &:hover {
    cursor: pointer;
  }
}

</style>
